import { PackageModulesFormGzDataProvider } from '../dataProvider/PackageModulesFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class PackageModulesFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PackageModulesFormGzDataProvider);
  }
}
